<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>福利社活动管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel :show-header="false">
      <el-form ref="form"
               :model="form"
               :rules="searchRules"
               label-width="120px"
               class="demo-ruleForm"
               @submit.native.prevent="onSubmit()">
        <el-row class="text item">
          <el-form-item prop="img"
                        label="图片:">
            <el-upload class="avatar-uploader"
                       action=""
                       :auto-upload="false"
                       :show-file-list="false"
                       :on-change="onChangeFile"
                       :on-remove="handleRemove">
              <img v-if="form.img"
                   :src="form.img"
                   class="avatar">
              <i v-else
                 class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item prop="url"
                        label="图片链接:">
            <el-input v-model="form.url"
                      placeholder="请输入图片链接"></el-input>
          </el-form-item>
          <el-form-item prop="priority"
                        label="优先级:">
            <el-input v-model="form.priority"
                      placeholder="请输入优先级，默认为1"
                      type="number"></el-input>
          </el-form-item>

          <el-form-item prop="upshelftime"
                        label="上架时间:">
            <el-date-picker v-model="form.upshelftime"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="downshelftime"
                        label="下架时间:">
            <el-date-picker v-model="form.downshelftime"
                            type="datetime"
                            placeholder="请选择下架时间"
                            value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-button type="primary"
                     size="mini"
                     native-type="submit"
                     v-if="loading">保存
          </el-button>
          <router-link :to="{ path: '/flbanner/table'}">
            <el-button type="primary"
                       size="mini">取消
            </el-button>
          </router-link>
        </el-row>
      </el-form>
    </layout-panel>

  </div>
</template>

<script>
import { searchRules } from '../flbanner.rules.js'

export default {
  data () {
    return {
      loading: true,
      searchRules,
      selectLoading: false,
      form: {
        id: this.$route.params.id,
        img: null,
        url: null,
        priority: 1, // 上架优先级默认为1
        upshelftime: null,
        downshelftime: null,
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.getFlBanner()
  },
  methods: {
    ...Vuex.mapActions(['getFlBanner', 'editFlBanner', 'uploadFlBanner']),
    getFlBanner () {
      return request.page('getFlBanner', this.form.id).then(({data}) => {
        filter.setLoop(this.form, data)
      })
    },
    handleRemove (file, fileList) {
      this.form.img = ''
    },

    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (filter.toUnix(this.form.upshelftime) >= filter.toUnix(this.form.downshelftime)) {
            this.$message.error('上线时间不能大于下线时间！')
            return false
          }
          return request.common('editFlBanner', this.form).then(({data}) => {
            this.$message({
              showClose: true,
              message: '创建成功',
              type: 'success',
            })
            this.loading = false
            window.location.href = '/flbanner/table'
          })
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    onChangeFile (file, fileList) {
      let isExcel = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
      let isLt2M = file.raw.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt2M) {
        this.$message.error('大小不能超过2MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.OnUploadFile(file.raw)
    },
    OnUploadFile (file) {
      let formData = new FormData()
      formData.append('file', file)
      return request.common('uploadFlBanner', formData).then(({data}) => {
        this.form.img = data
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
  },

}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/flbanner/pages/FlBannerUpdate.vue